import { Button } from "@/components/Button";
import GradientWaitingRoom from "@/components/GradientWaitingRoom";
import { getAppConfig } from "@/utils/appManager";
import { MAILTO_SUPPORT } from "@/utils/const";
import { faCaretRight } from "@fortawesome/pro-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const Profile = () => {
  const { t } = useTranslation();

  const secondsRemainingRef = useRef(30);
  const [secondsRemaining, setSecondsRemaining] = useState<number>(
    secondsRemainingRef.current,
  );
  const { shopifyAppInstallUrl } = getAppConfig();

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      if (secondsRemainingRef.current > 0) {
        secondsRemainingRef.current -= 1;
        setSecondsRemaining(secondsRemainingRef.current);
      } else {
        window.location.href = shopifyAppInstallUrl;
      }
    }, 1000);

    return () => {
      clearInterval(countdownInterval);
    };
  }, [secondsRemainingRef]);

  const renderCtas = () => (
    <div className="mt-30 flex flex-row flex-wrap items-center justify-center gap-30 md:flex-nowrap md:justify-normal">
      <Button
        as="a"
        trackingId={{ eventName: "onboarding.collect.access-shopify-listing" }}
        variant="white-background"
        href={shopifyAppInstallUrl}
        role="link"
        width="lg"
        target="_self">
        {t("emailOnboarding.profile.cta")}
      </Button>
      <div className="flex min-w-full items-center justify-center md:justify-normal">
        <Button
          as="a"
          trackingId={{ eventName: "support.mailto" }}
          variant="white-link"
          iconPosition="end"
          icon={faCaretRight}
          iconColor="text-secondary"
          iconClassName="w-15 h-15"
          href={MAILTO_SUPPORT}
          role="link">
          {t("components.cta.needHelp")}
        </Button>
      </div>
    </div>
  );

  return (
    <GradientWaitingRoom
      whiteBackground={false}
      hideHeader={true}
      headingText={t("emailOnboarding.profile.heading")}
      descriptionText={t("emailOnboarding.profile.description", {
        seconds: secondsRemaining,
      })}>
      {renderCtas()}
    </GradientWaitingRoom>
  );
};

export default Profile;
